<template>
  <div class="row">
    <div class="col-lg-2 col-xs-12"></div>
    <div class="col-lg-8 col-xs-12 videoPainel bg-white p-3 shadow_bar">
      <!-- <sweetalert-icon icon="success" /> -->

      <h2 class="center color-primary" style="color: #000" v-html="label" />

      <transition name="fade">
        <sweetalert-icon v-if="!icon_success" icon="loading" />
        <sweetalert-icon v-if="icon_success" icon="success" />
      </transition>
      <h6
        v-if="job.final_message"
        class="mt-3 center"
        v-html="job.final_message"
      />
      <h6 v-if="account_uid == 'cektp8b4'" class="ml-3">
        <p>
          Agradecemos por ter participado da primeira etapa do Programa de
          Trainees Credit Suisse 2023.
        </p>
        <p>Seu teste on-line foi concluído.</p>
        <p>
          A próxima etapa é aguardar. Caso você seja selecionado(a), o time do
          Credit Suisse entrará em contato com você para seguir com a próxima
          etapa do processo seletivo, o agendamento das entrevistas on-line.
        </p>
        <p>Desejamos sucesso e boa sorte!</p>
        <p>
          Para saber mais sobre dicas e conteúdos de carreira, acesse os canais
          da Mappit.
        </p>

        <a href="https://mappit.com.br/home">https://mappit.com.br/home</a
        ><br />
        <a href="https://www.linkedin.com/company/mappit-talenses-group/"
          >https://www.linkedin.com/company/mappit-talenses-group/</a
        >
        <p>
          Caso precise de ajuda ou tenha algum problema sua inscrição, entre em
          contato contato@mappit.com.br
        </p>
      </h6>
      <h4 v-if="show" class="mt-3 mb-2 color-grey center">
        AUMENTE SUAS CHANCES, FAÇA UPLOAD DE SEU CURRÍCULO PDF/DOC
      </h4>
      <p v-if="show" class="center">
        SE VOCÊ ESTIVER NO CELULAR E NÃO TIVER O CURRÍCULO EM SEU APRELHO, USE
        ESSA MESMA URL PARA ACESSAR OUTRA VEZ EM UM COMPUTADOR
      </p>
      <CurriculumUpload v-if="show" />
      <div v-if="show" class="center">
        <button
          v-if="finished"
          :disabled="load"
          class="btn mt-4 btn-success btn-lg"
          @click="destroySession"
        >
          <span v-show="!load">FINALIZAR CADASTRO</span>
          <div v-show="load" class="spinner-border text-light" role="status">
            <span class="sr-only"></span>
          </div>
        </button>
        <h4 v-if="!finished" class="mt-3 mb-2 color-grey center">
          CADASTRO FINALIADO, BOA SORTE!
        </h4>
      </div>
    </div>
    <div class="col-lg-2 col-xs-12"></div>
  </div>
</template>

<script>
import CurriculumUpload from "components/CurriculumUpload.vue";

export default {
  components: { CurriculumUpload },
  props: ["show", "job", "account_uid", "label"],
  data: () => ({
    icon_success: false,
    load: false,
    finished: "true",
  }),
  methods: {
    destroySession() {
      if (this.load) {
        this.$toast.error("Espere o upload terminar");
        return;
      }
      axios
        .delete(
          "/candidates/sessions?job_uid=" +
            this.job.uid +
            "&account_uid=" +
            this.account_uid
        )
        .then((response) => {
          this.finished = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.icon_success = true;
    }, 900);

    const postback_url = localStorage.getItem("postback_url");
    if (postback_url) {
      fetch(postback_url).then((response) => {
        console.log("RODOU POSTBACK");
      });
      localStorage.removeItem("postback_url");
    }

    axios.post("/candidates/apply/send_conclusion_email", {
      jobs: {
        uid: this.job.uid,
        account_uid: this.account_uid,
      },
    });

    localStorage.setItem("timer_second", "end");
    localStorage.setItem("timer_minute", "end");
    this.destroySession();

    eventBus.$on("curriculum_load", (flag) => {
      this.load = flag;
      if (!flag) {
        this.$toast.success("Currículo carregado com sucesso");
      }
    });
  },
};
</script>

<style></style>
